import React from "react";

export default function TermsOfUsePage() {
  return (
    <div className="min-h-screen bg-[#FAFAF8] px-4 py-12"
      style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl tracking-[0.25em] uppercase font-light text-[#1A1A1A] mb-2">Arvay</h1>
        <p className="font-sans text-[10px] uppercase tracking-[0.25em] text-neutral-400 font-medium mb-12">Terms of Use</p>

        <div className="space-y-8 font-sans text-sm text-[#1A1A1A] leading-relaxed">
          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-2">1. Content Aggregation</h2>
            <p>Arvay aggregates content from third-party RSS feeds and APIs. All articles, headlines and media remain the intellectual property of their respective publishers. Arvay does not claim ownership of any third-party content.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-2">2. No Moderation</h2>
            <p>Content displayed on Arvay is not moderated or verified by Arvay. Arvay makes no representations about the accuracy, completeness or reliability of any content sourced from third parties.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-2">3. Age Requirement</h2>
            <p>You must be 17 years of age or older to use Arvay. By accessing the platform you confirm that you meet this requirement.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-2">4. Content Reporting</h2>
            <p>Users may report content via the in-app Report button. Arvay will review reported content and reserves the right to remove any source from the platform at its sole discretion.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-2">5. Source Management</h2>
            <p>Arvay reserves the right to add, remove, or modify integrated sources at any time without prior notice.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-2">6. Limitation of Liability</h2>
            <p>Arvay is not liable for any damages arising from reliance on third-party content displayed on the platform. Use of Arvay is at your own risk.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-2">7. Contact</h2>
            <p>For questions or concerns, contact us at <a href="mailto:support@arvay.live" className="underline">support@arvay.live</a>.</p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-[#E0E0E0]">
          <a href="/" className="font-sans text-[10px] uppercase tracking-[0.18em] font-semibold text-neutral-500 hover:text-black">
            ← Back to Arvay
          </a>
          <p className="font-sans text-[9px] text-neutral-300 mt-4">Last updated: {new Date().getFullYear()}</p>
        </div>
      </div>
    </div>
  );
}
